export default __webpack_public_path__ + "static/media/demonmaw.c5e77526.png";